import React from "react";
import styled, { keyframes } from "styled-components";
import { Link, useParams } from "react-router-dom";
import Caroussel from "../../components/core-components/Caroussel.tsx";
import { AiOutlineHome } from "react-icons/ai";
import {
  getProductDetails,
  // uploadImage,
} from "../../../services/productsService.js";
import { useQuery } from "@tanstack/react-query";
import Button from "../../components/core-components/Button.tsx";
import { translations } from "../../../utils/translations.js";
import { useDispatch, useSelector } from "react-redux";
import Cips from "../../components/core-components/Cips.tsx";
import { IoIosColorPalette } from "react-icons/io";
import { TbRulerMeasure2 } from "react-icons/tb";
import { GiFilmSpool } from "react-icons/gi";
import Reviews from "../../components/Reviews.tsx";
import { dataActions } from "../../../store/index.js";
import { toast, ToastContainer } from "react-toastify";
import { calculateDiscountedPrice } from "../../../utils/utils.ts";
import { URLPOZE } from "../../../utils/constants.ts";

const Wrapper = styled.div`
  width: 90%;
  height: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;

const Breadcrumbs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  color: var(--tertiary-font-color);
  margin: 1rem 0;
  width: 100%;
  font-size: 14px;

  & > a {
    color: var(--tertiary-font-color);
    cursor: pointer;
    align-items: center;
    display: flex;
  }
`;

const ProductDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }

  & > div {
    flex: 1;
  }
`;

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 1300px) {
    max-width: 40%;
  }
`;

const CarouselContainer = styled.div`
  width: 100%;
  max-width: 550px;
`;

const DetailsRow = styled.div`
  font-family: Georgia, serif;

  color: var(--secondary-font-color);
  font-size: 14px;
`;
const CipsRow = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  gap: 8px;
  padding: 12px 0;
  font-size: 12px;
  flex-wrap: wrap;
`;
const PriceRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10%;
  font-family: Georgia, serif;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;
const Price = styled.p`
  font-family: Georgia, serif;
  color: var(--secondary-font-color);
  font-size: 20px;
`;

const ProductPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

const StrikePrice = styled.div`
  font-family: Verdana, sans-serif;
  text-decoration: line-through;
  color: var(--tertiary-font-color);
  font-size: 0.8rem;
`;

const DetailsText = styled.p`
  text-align: justify;
  line-height: 1.5;
  padding: 4px 0;
  margin: 0;
`;

const ProductName = styled.p`
  font-size: 24px;
  font-family: Georgia, serif;
  padding: 4px 0 16px 0;
  margin: 0;
`;
const Image = styled.img`
  width: 100%;
  height: 300px;
`;

const pulse = keyframes`
  0% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #c0c0c0;
  }
  100% {
    background-color: #e0e0e0;
  }
`;

const SkeletonText = styled.div`
  margin-bottom: 16px;
  width: ${(props) => (props.$isShort ? "50%" : "100%")};
  height: 16px;
  background-color: #e0e0e0;
  border-radius: 4px;
  animation: ${pulse} 1.5s infinite ease-in-out;
`;

const SkeletonImage = styled.div`
  margin-bottom: 16px;
  width: 100%;
  height: 300px;
  background-color: #e0e0e0;
  border-radius: 4px;
  animation: ${pulse} 1.5s infinite ease-in-out;
`;

const ProductDetails = () => {
  const dispach = useDispatch();
  const { productId, categoryName } = useParams();
  const languageCode = useSelector((state) => state.settings.languageCode);

  const handleAddToCart = () => {
    dispach(
      dataActions.addProductToCart({
        id: productId,
        name: product?.productName,
        quantity: 1,
        price: product?.price,
        discount: product?.discount,
        image: product?.imageUrls[0] ?? "",
      })
    );
    notify();
  };
  const { data: product } = useQuery({
    queryKey: ["productDetails", productId],
    queryFn: () => getProductDetails(productId),
    retry: false,
  });

  // const product = {
  //   productId: 1,
  //   productName: "Product 1",
  //   description: "Description of product 1",
  //   productWeight: 100,
  //   productHeight: 100,
  //   productDepth: 100,
  //   price: 100,
  //   colorName: "Red",
  //   typeName: "Type 1",
  //   categoryName: "Category 1",
  //   customize: true,
  // };

  const handleImages = (images) => {
    return images.map((image, index) => (
      <Image key={index} src={`${URLPOZE}${image}`} alt={`Product ${index}`} />
    ));
  };
  const notify = () =>
    toast.success(translations[languageCode]["add-product-success"], {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "light",
    });
  return (
    <Wrapper>
      {/* <input type="file" onChange={(e) => uploadImage(e.target.files[0], productId)} /> */}

      <Breadcrumbs>
        <Link to={"/"}>
          <AiOutlineHome />
        </Link>{" "}
        <>
          {" "}
          {">"}{" "}
          <Link to={`/shop/${categoryName}`}>{product?.categoryName} </Link>{" "}
          {">"} <div>{product?.productName}</div>
        </>
      </Breadcrumbs>
      <ProductDetailsContainer>
        <CarouselContainer>
          <Caroussel
            content={
              product ? handleImages(product.imageUrls) : [<SkeletonImage />]
            }
          />
        </CarouselContainer>

        <DetailsContainer>
          <DetailsRow data-testid="product-category">
            {product ? (
              <DetailsText
                style={{ textTransform: "uppercase", fontSize: "12px" }}
              >
                {product?.categoryName}
              </DetailsText>
            ) : (
              <SkeletonText $isShort />
            )}
          </DetailsRow>
          <DetailsRow data-testid="product-title">
            {product ? (
              <ProductName>{product?.productName}</ProductName>
            ) : (
              <SkeletonText $isShort />
            )}
          </DetailsRow>
          <DetailsRow data-testid="product-description">
            {product ? (
              <DetailsText>{product?.description}</DetailsText>
            ) : (
              <>
                <SkeletonText /> <SkeletonText /> <SkeletonText />
              </>
            )}
          </DetailsRow>

          {product && (
            <CipsRow>
              {product?.customize && (
                <Cips
                  color="var(--primary-brown)"
                  inverted
                  text={translations[languageCode]["custom-product-cips"]}
                />
              )}
              <Cips
                color="var(--primary-brown)"
                inverted
                icon={<IoIosColorPalette style={{ fontSize: "16px" }} />}
                text={product?.colorName}
              />
              <Cips
                color="var(--primary-brown)"
                inverted
                text={product?.typeName}
                icon={<GiFilmSpool style={{ fontSize: "16px" }} />}
              />
              <Cips
                color="var(--primary-brown)"
                inverted
                icon={<TbRulerMeasure2 />}
                text={`${product?.productWeight} x ${product?.productDepth} x ${product?.productHeight} mm`}
              />
            </CipsRow>
          )}

          <PriceRow>
            {product ? (
              <>
                {product.discount ? (
                  <ProductPrice data-testid="product-price">
                    <Price>
                      {calculateDiscountedPrice(
                        product?.price,
                        product?.discount
                      )}{" "}
                      lei
                    </Price>
                    <StrikePrice>{product?.price} lei</StrikePrice>
                  </ProductPrice>
                ) : (
                  <Price>{product?.price} lei</Price>
                )}

                <Button
                  id="add-to-cart"
                  onClick={handleAddToCart}
                  text={translations[languageCode]["add-to-cart"]}
                  backgroundColor={"var(--secondary-green)"}
                  color="white"
                />
              </>
            ) : (
              <>
                <SkeletonText style={{ marginTop: "16px" }} />
                <SkeletonText style={{ marginTop: "16px" }} />
              </>
            )}
          </PriceRow>
        </DetailsContainer>
      </ProductDetailsContainer>
      {product && <Reviews productId={productId} />}
      <ToastContainer />
    </Wrapper>
  );
};

export default ProductDetails;
